// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2lnoV","visuallyhidden":"_3h7xd","hide-text":"_26WJh","center":"_1J8Ws","noprint":"_2jEhX","root":"_1DpAi","authorHeading":"_33dRh","authorLink":"_2PJn7","image":"_1g8yI","innerWrapper":"RABif","withImage":"_3VcBn","background":"_2F-oA","contactLink":"xc19v","contactLabel":"_2uLFH","contactItem":"_275X1","contacts":"_2ZttG","label":"_3eG1h"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-author-header/styles/AuthorHeader.scss
 ** module id = 934
 ** module chunks = 1
 **/